import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchPCSpecs} from '../actions/pcspec'
import PCSpec from '../components/PCSpec'
import {changeFilterDatas} from '../actions/filter'

const mapStateToProps = state => {
  const { pcspec } = state
  const {
    isFetching,
    lastUpdated,
    items,
    // totalRows
  } = pcspec || {
    isFetching: true,
    items: []
  }

  return {
    items,
    isFetching,
    lastUpdated,
    // totalRows,
    // userNames: state.pcspec.userNames,
    // hpa27Names: state.pcspec.hpa27Names,
    // pcNames: state.pcspec.pcNames, 
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPCSpecs: fetchPCSpecs,
      changeFilterDatas:changeFilterDatas,
      // getAppname: fetchAppname,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PCSpec)
